

<ng-container *ngIf="searchSubject | async">

    <ng-container *ngFor="let searchPart of searchSplitArrayObs | async">
        <ng-container *ngIf="searchPart.toLowerCase() === (searchSubject | async).toLowerCase()"> 
            <span class="highlight-span">{{searchPart}}</span>
        </ng-container>
        <ng-container *ngIf="searchPart.toLowerCase() !== (searchSubject | async).toLowerCase()">{{searchPart}}</ng-container>
    </ng-container>
    
</ng-container>

<ng-container *ngIf="!(searchSubject | async)">
    {{valueSubject | async}}
</ng-container>

